
export const ERRORS = {
    apiAuthError: "Åtkomst till faktura misslyckades, vänligen kontakta " + 
            "systemutvecklare@akademiskahus.se om problemet kvarstår.",
    fetchInvoice: "Hämta faktura misslyckades",
    invoiceDataMissing: "Invoice data is missing in the response.",
    noGroupMembership: "Kunde inte hämta API-token.",
    failToParseLoginState:"Kunde inte tolka inloggningsstatusen.",
    loginRedirectFail: "Omdirigering för inloggning misslyckades",
    noTokenFetched: "Kunde inte hämta API-token.",
    print: "Det gick inte att skriva ut filen, vänligen kontakta " + 
            "systemutvecklare@akademiskahus.se om problemet kvarstår.",
  };
  